/* Soulrang — premium motion driver.
   Assigns scroll-reveal / cascade classes across every content section
   (custom sections included) and reveals them as they enter the viewport.
   Skips the sticky scroll-story section, the theme editor, and honours
   prefers-reduced-motion. */
(function () {
  var root = document.documentElement;
  root.classList.add('sr-motion');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // In the theme editor, keep everything visible so editing isn't disrupted.
  if (reduce || (window.Shopify && window.Shopify.designMode)) return;

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sr-in');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  // Failsafe: reveal any still-hidden element that is within the viewport.
  // Guards against IntersectionObserver being throttled (e.g. the page was
  // opened in a background tab) so content is never left stuck invisible.
  function flushVisible() {
    document
      .querySelectorAll('.sr-reveal:not(.sr-in), .sr-cascade:not(.sr-in)')
      .forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('sr-in');
          observer.unobserve(el);
        }
      });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) flushVisible();
  });
  window.setTimeout(flushVisible, 2500);

  function collectSections() {
    var list = [];
    var main = document.getElementById('MainContent');
    if (main) {
      main.querySelectorAll(':scope > .shopify-section').forEach(function (s) {
        list.push(s);
      });
    }
    // Custom footer lives outside <main>.
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('.footer-scenic') && list.indexOf(s) === -1) list.push(s);
    });
    return list;
  }

  function primeHeading(section) {
    var heading = section.querySelector('.title-wrapper, .section-heading, .title, h2');
    if (heading && !heading.classList.contains('sr-reveal')) {
      heading.classList.add('sr-reveal');
      observer.observe(heading);
    }
  }

  function init() {
    // Opt-in per-element reveals: any element marked [data-sr-item] reveals
    // itself as it enters view. Used by long editorial sections (e.g. Our
    // Story) so each movement animates in on scroll rather than the whole
    // tall section flashing in at once. The class is added here (not in the
    // markup) so content is never left hidden if this script fails to run.
    document.querySelectorAll('[data-sr-item]').forEach(function (el) {
      if (el.classList.contains('sr-reveal') || el.classList.contains('sr-cascade')) return;
      el.classList.add('sr-reveal');
      observer.observe(el);
    });

    collectSections().forEach(function (section) {
      // Leave the pinned scroll-story alone — animating its wrapper breaks sticky.
      if (section.querySelector('.scroll-story')) return;

      // Sections that manage their own per-element reveals opt out of the
      // whole-section reveal so the two don't double up.
      if (section.querySelector('[data-sr-item]')) return;

      var items = section.querySelectorAll(
        '.product-card-wrapper, .grid__item, .category-icon, .multicolumn-card, .collage__item'
      );

      if (items.length >= 2) {
        // Grid section: ripple the items in, and softly reveal the heading above.
        primeHeading(section);
        Array.prototype.forEach.call(items, function (item, i) {
          if (item.classList.contains('sr-cascade')) return;
          item.classList.add('sr-cascade');
          item.style.setProperty('--sr-i', i % 8);
          observer.observe(item);
        });
      } else if (!section.classList.contains('sr-reveal')) {
        // Standard section: reveal it as a single unit.
        section.classList.add('sr-reveal');
        observer.observe(section);
      }
    });
  }

  // Subtle parallax on the big full-bleed banner images (hero, campaign
  // banner) — the image drifts a little slower than the page scrolls,
  // clipped by the slide/section's own overflow:hidden so it never spills
  // past its frame. Pure transform, rAF-throttled, paused off-screen.
  function initParallax() {
    var els = document.querySelectorAll('.hero-banner__media, .campaign-banner__media');
    if (!els.length) return;

    var maxShift = 28; // px, matches the CSS oversize buffer
    var ticking = false;
    var visible = [];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = visible.indexOf(entry.target);
          if (entry.isIntersecting && idx === -1) {
            visible.push(entry.target);
          } else if (!entry.isIntersecting && idx !== -1) {
            visible.splice(idx, 1);
            entry.target.style.transform = '';
          }
        });
      },
      { rootMargin: '15% 0px 15% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      visible.forEach(function (el) {
        var frame = el.closest('.hero-banner__slide, .campaign-banner');
        if (!frame) return;
        var rect = frame.getBoundingClientRect();
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var offset = Math.max(-1, Math.min(1, progress)) * maxShift;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
